import { LanguageCode } from '@/utils/localisation'

import { isoCountriesDescriptions } from '../domain/countryDescriptions'

export const getCountryName = (countryCode: string, currentLanguage: LanguageCode) => {
  return isoCountriesDescriptions[countryCode]?.[currentLanguage]
}

export const getCountryDisplayNameFromCode = (countryCode: string, currentLanguage: LanguageCode) => {
  const countryName = getCountryName(countryCode, currentLanguage)
  return countryName ? `${countryName} (${countryCode})` : countryCode
}
